import { SpezifikationsArt } from '../../mdqx-graphql-types';

export class SpezifikationsArtEntity {
    public static readonly GqlFields = 'id name';

    public Id: number;
    public Name: string;

    constructor(SpezifikationsArtType: SpezifikationsArt | null) {
        if (
            SpezifikationsArtType &&
            SpezifikationsArtType.id != null &&
            SpezifikationsArtType.name != null
        ) {
            this.Id = SpezifikationsArtType.id;
            this.Name = SpezifikationsArtType.name;
        } else {
            console.error('received broken SpezifikationsArtType', SpezifikationsArtType);
            throw Error();
        }
    }
}
